import { useLayoutEffect, useState } from 'react'

// Room an overlay needs below its anchor before it opens upward instead;
// about six 36px rows. Assumed, like the menu height it serves.
const MIN_ROOM_BELOW = 220
const GAP = 4

/* Fixed-position coordinates for an overlay anchored to `anchorRef`, kept in
   step with scrolling and resizing. Overlays mount at the body (a portal), so
   a table's or card's overflow never clips them. align 'end' lines up the
   right edges, 'start' the left edges, 'center' the centres (tooltips). */
export function useAnchoredPosition(anchorRef, open, { align = 'end', placement = 'below' } = {}) {
  const [style, setStyle] = useState(null)
  useLayoutEffect(() => {
    if (!open) return undefined
    const update = () => {
      const anchor = anchorRef.current
      if (!anchor) return
      const rect = anchor.getBoundingClientRect()
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth
      const viewportHeight = window.innerHeight
      const below = viewportHeight - rect.bottom
      const upward = placement === 'above'
        ? rect.top >= MIN_ROOM_BELOW / 2 || rect.top > below
        : below < MIN_ROOM_BELOW && rect.top > below
      const next = { position: 'fixed' }
      if (upward) next.bottom = viewportHeight - rect.top + GAP
      else next.top = rect.bottom + GAP
      if (align === 'start') next.left = Math.max(GAP, rect.left)
      else if (align === 'center') { next.left = rect.left + rect.width / 2; next.transform = 'translateX(-50%)' }
      else next.right = Math.max(GAP, viewportWidth - rect.right)
      setStyle(next)
    }
    update()
    window.addEventListener('resize', update)
    window.addEventListener('scroll', update, true)
    return () => {
      window.removeEventListener('resize', update)
      window.removeEventListener('scroll', update, true)
    }
  }, [align, anchorRef, open, placement])
  return style ?? { position: 'fixed' }
}
